<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Solicitudes de cambio de documentos
            a.button.is-dark.is-rounded(@click="backPage")
              i.fas.fa-times
        .columns
          .column.is-12.has-text-centered
            .table-responsive
              table#tblLogs.table.is-striped.is-fullwidth
                thead
                  tr
                    th #
                    th Usuario
                    th Puesto
                    th Tipo de documento
                    th Origen del cambio
                    th Razon del cambio
                    th Estado actual
                    th Cambio propuesto
                    th Estado de la solicitud
                    th Razon del resultado
                    th Fecha
                    th Acciones
                tbody
                  tr(v-for="(data, index) in logs" :key="data.id")
                    td {{ data.id }}
                    td
                      span {{ data.user_name }}
                    td {{ data.user_work_job }}
                    td {{ orígenes[data.origin_of_change] }}
                    td {{ tipos[data.document_type] }}
                    td {{ data.reason_for_change }}
                    td {{ data.current_status }}
                    td {{ data.proposed_change }}
                    td
                      span {{ estados[data.assessment_result] }}
                    td {{ data.reason_for_assessment_result }}
                    td {{ data.created_at }}
                    td
                      .buttons
                        a.button.is-black.is-rounded.is-size-7(@click="downloadVoucher(data.id)" v-if="data.media_count == 0")
                          i.fas.fa-eye
                        a.button.is-danger.is-rounded.is-size-7(@click="openReasonModal(3, data.id)" v-if="data.assessment_result == 1 && data.media_count == 0")
                          i.fas.fa-times
                        a.button.is-success.is-rounded.is-size-7(@click="openReasonModal(2, data.id)" v-if="data.assessment_result == 1 && data.media_count == 0")
                          i.fas.fa-check
                        a.button.is-black.is-rounded.is-size-7(@click="addFile(data.id)" v-if="data.media_count == 0 && data.assessment_result != 1")
                          i.fas.fa-cloud
                        a.button.is-dark.is-rounded.is-size-7(@click="downloadVoucher(data.id)" v-if="data.media_count != 0")
                          i.fas.fa-eye
        input#fileInput(type="file" style="display: none" @change="handleFileChange" ref="fileInput")

        // Modal para ingresar la razón
        div.modal(v-if="showReasonModal")
          div.modal-background(@click="showReasonModal = false")
          div.modal-card
            div.modal-card-head
              p.modal-card-title {{ actionType === 2 ? 'Aprobar' : 'Rechazar' }} Solicitud
              button.delete(@click="showReasonModal = false")
            div.modal-card-body
              textarea(v-model="reason" placeholder="Ingrese la razón" rows="4" class="textarea")
            div.modal-card-foot
              button.button.is-success(@click="changeStatus") Enviar
              button.button.is-light(@click="showReasonModal = false") Cancelar

</template>

<script>
import { mapState } from "vuex";
import sasisopaAPI from "@/services/axios_sasisopa.js";
import Loader from '@/components/shared/Loader.vue';
import NavBarCORP from '@/components/layout/NavBarCorpo.vue';

export default {
  name: 'ChangeRequests',
  components: { Loader, NavBarCORP },
  data() {
    return {
      isLoading: false,
      logs: [],
      changeId: null,
      reason: '', // Nueva propiedad para almacenar la razón
      showReasonModal: false, // Controlar la visibilidad del modal
      actionType: null, // Para saber si es palomita o tache
      orígenes: [
        "",
        "Sugerencia",
        "Recomendación ICR",
        "Cambio de tecnología",
        "Hallazgo de auditoría",
        "Acción de mejora",
        "Cambio en el proceso"
      ],
      tipos: [
        "",
        "Manual",
        "Instructivo",
        "Plan",
        "Procedimiento",
        "Programa",
        "Formato"
      ],
      estados: [
        "",
        "GENERADO",
        "APROBADO",
        "RECHAZADO"
      ]
    }
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await sasisopaAPI.getSolicitudes(this.$route.params.id);
        console.log(response);
        this.logs = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },

    backPage() {
      this.$router.back();
    },

    openReasonModal(action, id) {
      this.actionType = action; // Establecer el tipo de acción (palomita o tache)
      this.changeId = id; // Establecer el ID
      this.reason = ''; // Reiniciar la razón
      this.showReasonModal = true; // Mostrar el modal
    },

    async changeStatus() {
      if (!this.reason) {
        alert("Por favor, proporciona una razón.");
        return;
      }

      try {
        const data = {
          id: this.changeId,
          assessment_result: this.actionType, // Usar el tipo de acción
          reason_for_assessment_result: this.reason, // Usar la razón proporcionada
        };
        const response = await sasisopaAPI.changeStatusSolicitudes(data);
        this.downloadVoucher(this.changeId);
        this.fetchData();
      } catch (error) {
        console.error('Error al cambiar el estado:', error);
      } finally {
        this.showReasonModal = false; // Cerrar el modal
      }
    },

    async downloadVoucher(id) {
      this.isLoading = true;
      const response = await sasisopaAPI.getRequestVoucher(id);
      this.isLoading = false;
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'voucher_solicitud_cambio.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    },

    addFile(id) {
      this.changeId = id;
      this.$refs.fileInput.click();
    },

    async handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        try {
          const data = {
            id: this.changeId,
            file: file,
          };
          const response = await sasisopaAPI.postChangeVoucher(data);
          this.fetchData();
          return response;
        } catch (error) {
          console.error('Error al guardar el archivo:', error);
        }
      }
    }
  },
  computed: {
    ...mapState(["logueado", "userLogin"])
  },
  created() {
    console.log("created");
    this.fetchData();
  }
}
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-card {
  width: 80%;
  max-width: 600px;
}

.modal-card-head {
  background-color: #f5f5f5;
}

.modal-card-body {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/sasisopa/ChangeRequests.vue